// Importing required libraries and components
import React, { useState } from 'react';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import { images } from '../../constants';

import './Footer.scss';

// Footer component
const Footer = () => {
  // State variables
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { name, email, message } = formData;
  const currentYear = new Date().getFullYear();

  // Handle input change
  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = () => {
    setLoading(true);
    const contact = {
      _type: 'contact',
      name: name,
      email: email,
      message: message,
    };

    // Create contact in the backend
    client
      .create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));
  };

  // Render the Footer component
  return (
    <>
      <h2 className="head-text">
      Impressed? Let's <span>work</span> together. Contact me!
      </h2>
      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:Abubakra7mad@gmail.com" className="p-text">
            Abubakra7mad@gmail.com
          </a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="mobile" />
          <a href="tel:+971568906808" className="p-text">
               +971568906808
          </a>
        </div>
      </div>
     
      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input
              className="p-text"
              type="text"
              placeholder="Your Name"
              name="name"
              value={name}
              onChange={handleChangeInput}
            />
          </div>
          <div className="app__flex">
            <input
              className="p-text"
              type="email"
              placeholder="Your Email"
              name="email"
              value={email}
              onChange={handleChangeInput}
            />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>
          <button className="p-text" type="button" onClick={handleSubmit}>
            {loading ? 'Sending...' : 'Send Message'}
          </button>
          
        </div>
      ) : (
        <div>
          <h3 className="head-text">Thank you for getting in touch!</h3>
        </div>
      )}
      <div className='copyright'>
        <p className='p-text'>@{currentYear} Abubakr ahmed</p>
        <p className='p-text'>All rights reserved.</p>
      </div>
    </>
    
  );
};

// Export the wrapped Footer component
export default AppWrap(MotionWrap(Footer, 'app__footer'), 'contact', 'app__whitebg');
